import { render, staticRenderFns } from "./demandCard.vue?vue&type=template&id=4a02a8cd&scoped=true&"
import script from "./demandCard.vue?vue&type=script&lang=js&"
export * from "./demandCard.vue?vue&type=script&lang=js&"
import style0 from "./demandCard.vue?vue&type=style&index=0&id=4a02a8cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a02a8cd",
  null
  
)

export default component.exports